import { render, staticRenderFns } from "./advertising.vue?vue&type=template&id=017c9856&scoped=true&"
import script from "./advertising.vue?vue&type=script&lang=js&"
export * from "./advertising.vue?vue&type=script&lang=js&"
import style0 from "./advertising.vue?vue&type=style&index=0&id=017c9856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017c9856",
  null
  
)

export default component.exports